<template>
 <nav class="navDays">

   <v-dialog @keydown.esc="dialog = false" v-model="dialog" color="white">
    
    

    <v-date-picker
            v-model="day"
            :first-day-of-week="4"
            picker-date
            :max="nowDate"
          ></v-date-picker>
   </v-dialog>

   <v-bottom-navigation 
      color="primary" flat
    >
      <v-btn @click="prev()">
        <span>Previous</span>

        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-text-field
            @click.stop="dialog = true"
            prepend-icon="mdi-calendar"
            readonly
            :value="day"
          ></v-text-field>
      <v-btn :disabled="viewingToday" @click="next()">
        <span>Next</span>

        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-bottom-navigation>
 </nav>
</template>
<style>.navDays { position: fixed;bottom: 40px; right: 4px;  }

@media (max-width: 480px) {

.navDays { right: 0; width: 100% }

}
</style>
<script>
import { mapState } from 'vuex'
  export default {

    data() {
            return {
       
              
              day : new Date().yyyymmdd(),
              
              dialog : false,
              nowDate: new Date().yyyymmdd(),

              daysNav : false,

              viewingToday : true,
             
            }
        },

    mounted ()  {
      this.$store.commit('SET_CURRENTDATE', this.day)

    },

    computed: {

    //   getEndDate() {
    //  var endDate = new Date(this.date.getFullYear(), this.date.getMonth() );
    //  return endDate.toISOString().slice(0,10)
    // }
    

      },


      


      watch: {

          day (val) {
               const date = new Date(val + "T00:00:00")
              this.viewingToday = date.isToday() ? true : false


             this.$store.commit('SET_CURRENTDATE', val)

              this.$emit('reloadData', val)

             this.dialog = false

          }
            
        },


        methods : {

          prev() {

          const d = new Date(this.day + "T00:00:00")
                d.setDate(d.getDate() - 1);
                
                this.day = this.formatDate(d);
              },

          next () {

            const d = new Date(this.day + "T00:00:00")
                d.setDate(d.getDate() + 1);

                this.day = this.formatDate(d);
          },



            loadData(day) { 

              const date = new Date(day + "T00:00:00")
              this.viewingToday = date.isToday() ? true : false
              this.$emit('reloadData', day)
            }
        }
        
     
    
    
  }
</script>